export default "__VITE_ASSET__B82XJANp__"